import moment from 'moment'
import { BookingAPI } from "../api"
import { Invoice } from "./Invoice.class";
import { Customer } from "./Customer.class";
import { AreaBooking } from "./AreaBooking.class";
import { Contract } from "./Contract.class";
import i18n from '@/plugins/vue-i18n';

export class Booking {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    if (props.contract) this.contract = new Contract(props.contract);
    if (props.areaBookings && props.areaBookings.length) this.areaBookings = props.areaBookings.map(areaBooking => areaBooking = new AreaBooking(areaBooking)).sort((a, b) => { return new Date(a.startDate && a.startDate.iso ? a.startDate.iso : a.startDate) - new Date(b.startDate && b.startDate.iso ? b.startDate.iso : b.startDate) })
  }
  static async createBooking(formData) {
    const { data } = await BookingAPI.createBooking(formData)
    return new Booking(data.result)
  }
  static async editBooking(formData) {
    const { data } = await BookingAPI.editBooking(formData)
    return new Booking(data.result)
  }
  static async getBookingByArea(areaId) {
    const { data } = await BookingAPI.getBookingByArea(areaId)
    let res = data.result.map((item) => (item = new Booking(item)))
    for (let item of res) {
      if (item.invoices.length) item.invoices = item.invoices.map(invoice => (invoice = new Invoice(invoice)))
    }
    return res;
  }
  static async getBookingByAreaCustomer(areaId) {
    const { data } = await BookingAPI.getBookingByAreaCustomer(areaId)
    let res = data.result.map((item) => (item = new Booking(item)))
    for (let item of res) {
      if (item.invoices.length) item.invoices = item.invoices.map(invoice => (invoice = new Invoice(invoice)))
    }
    return res;
  }
  static async getBooking(bookingId) {
    const { data } = await BookingAPI.getBooking(bookingId)
    return new Booking(data.result)
  }
  static async cancelBooking(bookingId) {
    const { data } = await BookingAPI.cancelBooking(bookingId)
    return new Booking(data.result)
  }
  static async checkInMonthlyBooking(bookingId) {
    const { data } = await BookingAPI.checkInMonthlyBooking(bookingId)
    return new Booking(data.result)
  }
  static async checkInMonthlyBookingFirst(bookingId) {
    const { data } = await BookingAPI.checkInMonthlyBookingFirst(bookingId)
    return data.result
  }
  static async getBookingBetweenDateByMarket(formData) {
    let { data } = await BookingAPI.getBookingBetweenDateByMarket(formData)
    let res = data.result.map(item => item = new Booking(item));
    for (let item of res) {
      if (item.customer) item.customer = new Customer(item.customer)
      if (item.invoices.length) item.invoices = item.invoices.map(invoice => invoice = new Invoice(invoice, true))
      // if (item.areaBookings.length) item.areaBookings = item.areaBookings.map(areaBooking => areaBooking = new AreaBooking(areaBooking))
    }
    return res
  }
  static async getBookingBetweenDateByProject(formData) {
    const { data } = await BookingAPI.getBookingBetweenDateByProject(formData)
    return data.result.map(item => item = new Booking(item));
  }
  static async getBookingCheckinToday(formData) {
    const { data } = await BookingAPI.getBookingCheckinToday(formData)
    return data.result;
  }
  static async getBookingByCustomerLimit(formData) {
    const { data } = await BookingAPI.getBookingByCustomerLimit(formData)
    return data.result.map(item => new Booking(item));
  }


  get createdAtFormat() {
    let date = ''
    if (this.createdAt) {
      date = moment(this.createdAt).format('DD MMM YYYY')
    }
    return date
  }
  get createdAtFormatTH() {
    let date = ''
    if (this.createdAt) {
      date = moment(this.createdAt).format(`ddd ${i18n.t('at')} DD MMM YYYY`)
    }
    return date
  }
  get areaNames() {
    return [...new Set(this.areaBookings.map(item => item.area.name))].join(', ')
  }
  get areaBookingNames() {
    let names = []
    for (const areaBooking of this.areaBookings) {
      let productNames = areaBooking.products.map(p => p.name).join(',')
      names.push(`${areaBooking.area.name} (${areaBooking.diffDays} ${i18n.t('day')})${productNames ? '(' + productNames + ')' : ''}`)
    }
    return [...new Set(names)].join(', ')
  }
  get countCheckIn() {
    let checkInNumber = 0
    for (const areaBooking of this.areaBookings) {
      if (areaBooking.checkedInDate && areaBooking.checkedInDate.iso) checkInNumber++
    }
    return checkInNumber
  }
  get countAreaBookings() {
    return this.areaBookings.length || 0
  }
  get sumTotalValue() {
    return this.invoices.reduce((a, b) => a + (b.isSent ? b.totalValue : 0 || 0), 0)
  }
  get sumTotalUnpaidValue() {
    return this.invoices.reduce((a, b) => a + (b.isSent ? b.totalUnpaidValue : 0 || 0), 0)
  }
  get sumTotalPaidValue() {
    return this.invoices.reduce((a, b) => a + (b.isSent ? (b.totalValue - b.totalUnpaidValue) : 0 || 0), 0)
  }
  get statusText() {
    let text = ''
    if (this.type == 'daily') {
      if (this.status == 'cancelled') text = i18n.t('cancel')
      else if (this.status == 'confirmed') text = i18n.t('booking.booking_daily')
    } else if (this.type == 'monthly') {
      if (this.status == 'cancelled') text = i18n.t('cancel')
      else if (this.status == 'success' || this.contract) text = i18n.t('contract.already_do_contract')
      else if (this.status == 'confirmed') text = i18n.t('contract.waiting_for_contract')
    }
    return text
  }
  get statusColor() {
    let color = ''
    if (this.type == 'daily') {
      if (this.status == 'cancelled') color = 'error'
      else if (this.status == 'confirmed') color = 'info'
    } else if (this.type == 'monthly') {
      if (this.status == 'cancelled') color = 'error'
      else if (this.status == 'success' || this.contract) color = 'success'
      else if (this.status == 'confirmed') color = 'warning'
    }
    return color
  }
  get stallTypeText() {
    let text = ''
    if (this.type == 'monthly' && this.stallType) {
      text = this.stallType ? i18n.t(`contact.stall_type.${this.stallType}`) : '-'
    }
    return text
  }

}